import Splide from '@splidejs/splide';

export default class WCProductReviewsSlider {
    constructor() {
        this.reviewsSlider = document.querySelector(
            '.jsWcProductReviewsSlider',
        );

        if (this.reviewsSlider) {
            this.events();
        }
    }

    events() {
        this.initializeReviewsSlider();
    }

    initializeReviewsSlider() {
        // eslint-disable-next-line no-unused-vars
        this.activeSlider = new Splide(this.reviewsSlider, {
            type: 'loop',
            perPage: 2,
            perMove: 1,
            rewind: false,
            arrows: false,
            pagination: true,
            autoplay: true,
            interval: 3000,
            gap: '1.25rem',
            focus: 1,
            classes: {
                // Add classes for pagination.
                pagination: 'splide__pagination wcprms-slider__pagination', // container
            },
            breakpoints: {
                575: {
                    perPage: 1,
                    perMove: 1,
                },
            },
        }).mount();
    }
}
